import React from "react"
import * as api from "brandguard/api"
import GenerateCorrectionShared from "brandguard/components/generate.correction"

interface props {
	item: api.ImageSearchResponseItem
	onCorrectionComplete?: (correctedEventId: string) => void
}

export default function GenerateCorrection(props: props): JSX.Element {
	return <GenerateCorrectionShared item={props.item} corrections={api.images.corrections} progressLabel="image" onCorrectionComplete={props.onCorrectionComplete} />
}
